<template>
  <div>
    <v-card-title>
      <div class="mr-6 primary--text font-weight-bold text-subtitle-1">
        Pasta Seçenekleri
      </div>
      <v-divider></v-divider>
    </v-card-title>
    <v-select
      filled
      v-model="data.cakeOptions"
      chips
      deletable-chips
      :items="cakeStore.cakeOptions"
      multiple
      rounded
      placeholder="Lütfen Seçiniz"
      persistent-placeholder
      hide-details
      return-object
    />

    <template v-if="false">
      <v-card-title class="mt-9">
        <div class="mr-6 primary--text font-weight-bold text-subtitle-1">
          Pasta Süsleri
        </div>
        <v-divider></v-divider>
      </v-card-title>

      <v-card color="chip" rounded="xl" flat>
        <v-card-text>
          <v-slide-group
            v-model="data.cakeSus"
            class="ma-0"
            center-active
            multiple
          >
            <v-slide-item
              v-for="(item, index) in cakeStore.cakeSus"
              :key="index"
              v-slot="{ active, toggle }"
              :value="item.slug"
            >
              <v-card
                :color="active ? 'secondary' : 'nightDarkTon'"
                class="mr-3 overflow-hidden"
                rounded="xl"
                height="200"
                width="200"
                @click="toggle"
              >
                <v-img
                  height="200"
                  width="200"
                  :src="require(`@/assets/images/cake/${item.image}`)"
                  :gradient="
                    active
                      ? 'to  bottom, rgba(0,0,0,0.25), rgba(0,0,0,.5)'
                      : 'to  top, rgba(0,0,0,.5), rgba(0,0,0,.75)'
                  "
                >
                  <v-toolbar flat color="transparent">
                    <v-spacer></v-spacer>
                    <v-icon v-if="!active">{{
                      icons.mdiCheckboxBlankCircleOutline
                    }}</v-icon>
                    <v-icon v-else color="secondary">{{
                      icons.mdiCheckboxMarkedCircle
                    }}</v-icon>
                  </v-toolbar>
                  <div
                    class="pa-5"
                    style="
                      height: calc(100% - 64px);
                      display: inline-flex;
                      flex-direction: column;
                      justify-content: end;
                    "
                  >
                    <h6 class="text-body-1">{{ item.text }}</h6>
                    <v-chip small color="secondary">{{
                      item.price | currency
                    }}</v-chip>
                  </div>
                </v-img>
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-card-text>
      </v-card>
    </template>
    <v-card-title class="mt-9">
      <div class="mr-6 primary--text font-weight-bold text-subtitle-1">
        Diğer
      </div>
      <v-divider></v-divider>
    </v-card-title>

    <v-row dense>
      <v-col cols="4" v-if="cakeStore.data.cake.cakeType === 0">
        <v-select
          rounded
          filled
          v-model="data.cakeShape"
          :items="cakeStore.cakeShape"
          label="Pasta Şekili"
        />
      </v-col>
      <v-col :cols="cakeStore.data.cake.cakeType === 0 ? 4 : 6">
        <v-select
          rounded
          filled
          v-model="data.cakeCake"
          :items="cakeStore.cakeCake"
          label="Pasta Keki"
        />
      </v-col>
      <v-col :cols="cakeStore.data.cake.cakeType === 0 ? 4 : 6">
        <v-select
          rounded
          filled
          v-model="data.cakeCream"
          :items="cakeStore.cakeCream"
          label="Pasta Kreması"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-file-input
          rounded
          filled
          counter
          multiple
          chips
          v-model="data.image"
          @change="imagePreview"
          @focus="imageFocus"
          accept="image/png, image/jpeg"
          prepend-icon=""
          :prepend-inner-icon="icons.mdiCamera"
          placeholder="Görsel Yükleme"
          persistent-placeholder
          truncate-length="15"
        ></v-file-input>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-textarea
          v-model="data.contentNote"
          rounded
          filled
          dense
          label="İçerik Açıklaması"
          rows="6"
          placeholder="Pastanın hazırlanması aşamasında istediklerinizi yazın"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-textarea
          v-model="data.orderNote"
          rounded
          filled
          dense
          label="Sipariş Açıklaması"
          rows="6"
          placeholder="Pastanın hazırlanması aşamasında istediklerinizi yazın"
        />
      </v-col>
    </v-row>
    <v-row align="center" class="my-9">
      <v-col cols="12" md="6"> </v-col>
      <v-col cols="12" md="6">
        <v-btn
          color="secondary"
          class="text-capitalize"
          depressed
          rounded
          x-large
          block
          @click="continueStep()"
        >
          Devam Et
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from "@vue/composition-api";
import {
  mdiCamera,
  mdiCheckboxBlankCircleOutline,
  mdiCheckboxMarkedCircle,
} from "@mdi/js";
import { useRouter } from "@core/utils";

// Store
import { useCakeStore } from "@/stores/cake";

export default {
  setup() {
    // Store bağlantı
    const cakeStore = useCakeStore();

    // Utils
    const { route } = useRouter();
    const data = ref({
      cakeShape: "kare",
      cakeCream: "siyah",
      cakeCake: "siyah",
      cakeOptions: [],
      image: [],
      url: [],
      cakeSus: [],
      orderNote: "",
      contentNote: "",
    });
    const continueStep = async () => {
      cakeStore.data.content = data.value;

      cakeStore.increment();
    };
    const imageFocus = () => {
      data.value.url = [];
    };

    const imagePreview = () => {
      data.value.image.forEach((item, index) => {
        data.value.url.push(URL.createObjectURL(item));
      });
    };

    return {
      data,
      cakeStore,
      continueStep,
      imagePreview,
      imageFocus,
      icons: {
        mdiCheckboxBlankCircleOutline,
        mdiCheckboxMarkedCircle,
        mdiCamera,
      },
    };
  },
};
</script>

<style></style>
